import { render, staticRenderFns } from "./SelectCategoryMenuChild.vue?vue&type=template&id=154a9fa6&scoped=true"
import script from "./SelectCategoryMenuChild.vue?vue&type=script&lang=js"
export * from "./SelectCategoryMenuChild.vue?vue&type=script&lang=js"
import style0 from "./SelectCategoryMenuChild.vue?vue&type=style&index=0&id=154a9fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a9fa6",
  null
  
)

export default component.exports